import React from "react";
import "./palam_dropdown.scss";

import { Icon } from 'react-icons-kit';
import { user as userIcon} from 'react-icons-kit/feather/';

class Header extends React.PureComponent {
  constructor(props){
      super(props);
      this.state={open:false}
      
  }  

  componentDidMount(){
    document.addEventListener("mousedown", this.onMouseDown.bind(this));
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.onMouseDown.bind(this));
  }  

  onMouseDown(evt) {
    var isItemChild = false;

    // Traverste target tree upwards, to see if a parent of the
    // clicked item is a menu item.
    // this is nessecary, because i mix react synthetic events with native ones :(
    var testnode = evt.target;
    while (testnode && testnode.classList){
      if ( testnode.classList.contains('palam-dropdown-item')) {
        isItemChild = true;
        break;
      }
      testnode = testnode.parentNode;
    }
    // if anything but a menu item or the menu header is clicked, close the menu
    if (!(evt.target && (evt.target.id && evt.target.id === "palam-dropdown-header" ) || isItemChild) ){
      this.setState({open:false})
    }
  }

  onToggle() {
      this.setState({open: !this.state.open})
  }


    // TODO: outsource header content to navbar
  render() {
    let { children, username, ...rest } = this.props;

    let rootCssClass = "palam-dropdown";
    rootCssClass += this.state.open? " open" : "";
    return (
      <div className={rootCssClass}>
        <button
          onClick={this.onToggle.bind(this)}
          className="palam-dropdown-header"
          id="palam-dropdown-header"
          {...rest}
        >
          <Icon size={24} icon={userIcon} />
          <span className="palam-dropdown-header-label">{username}</span>
           
        </button>
        {this.state.open?<List>{children}</List>:null}
      </div>
    );
  }
}

class List extends React.PureComponent {
    render() {
      let { children } = this.props;
      return (
        <div className="palam-dropdown-list">
            {children}
        </div>
      );
    }
  }


class Item extends React.PureComponent {
  render() {
    let { label, renderIcon, ...rest } = this.props;
    return (
      <button className="palam-dropdown-item" {...rest}>
        <div className="palam-dropdown-item-child">{renderIcon && renderIcon()}</div><span className="palam-dropdown-item-child">{label}</span>  
      </button>
    );
  }
}

export { Header, Item };
